import { render, staticRenderFns } from "./DetailsHorizontalTimeline.vue?vue&type=template&id=200c1421&"
import script from "./DetailsHorizontalTimeline.vue?vue&type=script&lang=ts&"
export * from "./DetailsHorizontalTimeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports